var _defs, _path, _line, _path2, _line2, _line3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudIconMemoryHelperLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .memoryHelperline {\n        fill: none;\n        stroke: currentColor;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 2px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "memoryHelperline",
    d: "M23.84,26.23h0c-4.87-4.9-12.77-4.9-17.65,0h0c-4.87,4.9-4.87,12.84,0,17.74h0c4.87,4.9,12.77,4.9,17.65,0h0c1.77-1.78,2.9-3.97,3.38-6.26h0s3.87-2.04,3.87-2.04c.46-.24.46-.9,0-1.14l-3.87-2.03h0c-.48-2.3-1.61-4.49-3.38-6.27Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "memoryHelperline",
    x1: 9.82,
    y1: 35.1,
    x2: 19.63,
    y2: 35.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "memoryHelperline",
    d: "M26.82,5.95h0c4.77-4.77,12.5-4.77,17.27,0h0c4.77,4.77,4.77,12.5,0,17.27h0c-4.77,4.77-12.5,4.77-17.27,0h0c-1.73-1.73-2.84-3.86-3.31-6.1h0s-3.79-1.98-3.79-1.98c-.45-.23-.45-.88,0-1.11l3.79-1.98h0c.47-2.24,1.57-4.37,3.31-6.1Z"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "memoryHelperline",
    x1: 31.42,
    y1: 14.59,
    x2: 39.44,
    y2: 14.59
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "memoryHelperline",
    x1: 35.43,
    y1: 18.76,
    x2: 35.43,
    y2: 10.42
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudIconMemoryHelperLine);
export default __webpack_public_path__ + "static/media/cloud_icon_memory_helper_line.3c14c809daac09ffcd0d099916b008de.svg";
export { ForwardRef as ReactComponent };